
const eventview = [{"key":"eventview.title","string":"Dogodki, ki ste jih dodali"},{"key":"eventview.add_event_button","string":"Dodaj dogodek"},{"key":"eventview.no_event_added","string":"Niste še dodali nobenega dogodka na mednarodno platformo strokovnjakov"},{"key":"eventview.table.title","string":"Naslov"},{"key":"eventview.table.location","string":"Kraj"},{"key":"eventview.table.date","string":"Datum"},{"key":"eventview.gotowebsite","string":"Pojdi na spletno stran dogodka"},{"key":null,"string":null},{"key":null,"string":null},{"key":null,"string":null},{"key":null,"string":null}]

export default eventview



// WEBPACK FOOTER //
// ./src/i18n/sl/addevent/eventview.js